export function initSearchForm($) {
    $('.action__search').on('click', async () => {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const search = $('#search').val();
            const deactivated = !!$('#deactivated').prop('checked');
            const active = !!$('#active').prop('checked');
            urlParams.set('search', search);
            urlParams.set('deleted', deactivated);
            urlParams.set('active', !active && !deactivated ? true : active);
            // Чекбокса нет на других страницах — тогда параметр не ставим.
            if ($('#unmarked').length) {
                urlParams.set('unmarked', !!$('#unmarked').prop('checked'));
            }
            window.location.href = `?${urlParams.toString()}`;
        } catch (e) {
            alert(e);
        }
    });
}
